// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1skdU","type":"styles_type__3OL54","choices":"styles_choices__2So0W"};